import { useContext } from 'react';
import { GlobalVarsContext } from '../../context/GlobalVarsProvider';

export const useGlobalVars = () => {
    const context = useContext(GlobalVarsContext);

    if (context === undefined) {
        // En lugar de lanzar un error, devolver funciones vacías como fallback
        // Esto permite que los componentes funcionen sin romper la aplicación
        console.warn('useGlobalVars: GlobalVarsProvider not found, using fallback');
        return {
            getGlobalVar: () => null,
            setGlobalVar: () => { },
            resetGlobalVar: () => { }
        };
    }

    const { getGlobalVar, setGlobalVar, resetGlobalVar } = context;

    return { getGlobalVar, setGlobalVar, resetGlobalVar };
};
